import { ISODateString, isoDate } from './date';

export enum TermsVersion {
  ExistingClient = 'existing_client',
  NewClient = 'new_client',
}

/**
 * Data wdrożenia funkcji akceptacji regulaminu.
 * Użytkownicy zarejestrowani przed tą datą dostają klauzulę dla obecnych klientów.
 */
export const TERMS_DEPLOYMENT_DATE: ISODateString = isoDate('2026-03-31');

export class UserConsent {
  readonly registeredAt: ISODateString;
  readonly acceptedAt: ISODateString | null;

  constructor(data: { registeredAt: ISODateString; acceptedAt: ISODateString | null }) {
    this.registeredAt = data.registeredAt;
    this.acceptedAt = data.acceptedAt;
  }

  get requiresConsent(): boolean {
    return this.acceptedAt === null;
  }

  get requiredVersion(): TermsVersion {
    return this.registeredAt < TERMS_DEPLOYMENT_DATE
      ? TermsVersion.ExistingClient
      : TermsVersion.NewClient;
  }
}
